import React from 'react';
import { connect } from 'react-redux';

import { Table } from 'reactstrap';
import './styles.scss';
import { unitTransform, prepareNum } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';

const CalculateProfileResistance = props => ( // eslint-disable-line
  <div className="calculation">
    <section className="list-type calculate-installation-data">
      <div className="info mb-2">
        <div className="mb-2">
          {props.profileResistance.isSuitable ? (
            <React.Fragment>
              <span className='icon_check icon mr-2'/>
              {APP_TEXTS.CALCULATE_PROFILE_SUITABLE.Content}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span className='icon_uncheck icon mr-2'/>
              {APP_TEXTS.CALCULATE_PROFILE_NOT_SUITABLE.Content}
            </React.Fragment>
          )}
        </div>
        <div className="mb-2">
          {APP_TEXTS.APPLICATIONS_LABEL_PROFILE_FAMILY.Content}
          {(props.profileType && props.profileType["RunName"]) + " / " +
            (props.profileSize && props.profileSize["RunName"])}
          <br/>
          {APP_TEXTS.CALCULATE_PROFILE_MATERIAL.Content}
          {props.material && props.material["RunName"]}
        </div>

        <div className="mb-2">
          <h4>{APP_TEXTS.CALCULATE_PROFILE_CONDITIONS.Content}</h4>
          <div className="ml-2">
            <span>MSd &le; MRd</span><br/>
            {props.maximumDeviation.active && (<span>Iy [Wlim] &le; Iy [Profile]</span>)}
          </div>
        </div>
      </div>

      <Table className="profile-res-table" bordered size="sm">
        <tbody>
          <tr>
            <th scope="row">MRd</th>
            <td>
              {unitTransform(+props.profileResistance.MRd, true).from(defaultUnits.MOMENT).to(props.momentUnit)}
            </td>
            <td>{props.momentUnit}</td>
          </tr>
          <tr>
            <th scope="row">MSd</th>
            <td>
              {unitTransform(+props.profileResistance.MSd, true).from(defaultUnits.MOMENT).to(props.momentUnit)}
            </td>
            <td>{props.momentUnit}</td>
          </tr>
          {props.maximumDeviation.active && (
            <React.Fragment>
              <tr>
                <th scope="row">{APP_TEXTS.CALCULATE_PROFILE_DEVIATION_WLIM.Content}</th>
                <td>
                  {prepareNum(+props.maximumDeviation.value, false, 4)}
                </td>
                <td></td>
              </tr>
              <tr>
                <th scope="row">{APP_TEXTS.CALCULATE_PROFILE_IY.Content}</th>
                <td>
                  {prepareNum(props.profileResistance.Iy, false)}
                </td>
                <td>mm4</td>
              </tr>
              <tr>
                <th scope="row">{APP_TEXTS.CALCULATE_PROFILE_IY_WLIM.Content}</th>
                <td>
                  {prepareNum(props.profileResistance.Iywlim, false)}
                </td>
                <td>mm4</td>
              </tr>
            </React.Fragment>
          )}
        </tbody>
      </Table>
    </section>
  </div>
);

const mapState = state => {
  let profile = state.selectors.application[state.main.appType].profile;
  let profileType = null, profileSize = null, material = null;
  if (profile) {
    if (state.webServices.profile.profileTypes)
      profileType = state.webServices.profile.profileTypes.find(x => x["InternalName"] === profile.family);
    if (state.webServices.profile.profileSizes)
      profileSize = state.webServices.profile.profileSizes.find(x => x["InternalName"] === profile.size);
    if (state.webServices.profile.materialNames)
      material = state.webServices.profile.materialNames.find(x => x["InternalName"] === profile.material);
  }
  return {
    profileResistance: state.selectors.calculate[state.main.appType].profileResistance,
    maximumDeviation: state.selectors.design[state.main.appType].maximumDeviation,
    material,
    profileType,
    profileSize,
    momentUnit: state.main.units.moment
  };
};

export default connect(mapState)(CalculateProfileResistance);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateProfileResistance/index.js